const SAMPLE_DOWNLOAD_MEMBER = {
  memberFile: null,
  memeberSampleLoading: false,
  memberSampleError: null,
};

const BULK_UPLOAD_MEMBER = {
  finalStatus: null,
  bulkUploadLoading: false,
  bulkUploadError: null,
};

const ATTRIBUTE_STATE = {
  attributes: null,
  attributeLoading: false,
  attributeError: null,
};
const CREATE_ATTRIBUTE_STATE = {
  createAttribute: null,
  createAttributeLoading: false,
  createAttributeError: null,
};

const UPDATE_ATTRIBUTE_STATE = {
  updateAttribute: null,
  updateAttributeLoading: false,
  updateAttributeError: null,
};

const DELETE_ATTRIBUTE_STATE = {
  deleteAttribute: null,
  deleteAttributeLoading: false,
  deleteAttributeError: null,
};

const CREATE_MEMBER_STATE = {
  createMember: null,
  createMemberLoading: false,
  createMemberError: null,
};

const MEMBER_LIST_STATE = {
  memberList: null,
  memberListLoading: false,
  memberListError: null,
};

const CLIENT_MEMBER_LIST_STATE = {
  clientMemberList: null,
  clientMemberListLoading: false,
  clientMemberListError: null,
};

const CLIENT_MEMBER_STATS = {
  clientMemberStats: null,
  clientMemberStatsLoading: false,
  clientMemberStatsError: null,
 
};

const CLIENT_MEMBER_DETAILS = {
  clientMemberDetails: null,
  clientMemberDetailsLoading: false,
  clientMemberDetailsError: null,
}

const ORG_KYC_USERS_LIST_STATE = {
  orgKycUsersList: null,
  orgKycUsersTotal: 0,
  orgKycUsersListLoading: false,
  orgKycUsersListError: null,
};

const deliveryTrendState = {
  data: {},
  loading: false,
  error: null,
};

const quickState = {
  data: {},
  loading: false,
  error: null,
};

const riskStatusState = {
  data: {},
  loading: false,
  error: null,
};




export {
  riskStatusState,
  quickState,
  deliveryTrendState,
  SAMPLE_DOWNLOAD_MEMBER,
  BULK_UPLOAD_MEMBER,
  ATTRIBUTE_STATE,
  CREATE_ATTRIBUTE_STATE,
  UPDATE_ATTRIBUTE_STATE,
  DELETE_ATTRIBUTE_STATE,
  CREATE_MEMBER_STATE,
  MEMBER_LIST_STATE,
  CLIENT_MEMBER_LIST_STATE,
  CLIENT_MEMBER_STATS,
  CLIENT_MEMBER_DETAILS,
  ORG_KYC_USERS_LIST_STATE
};
